import { useEffect, useRef } from 'react';

export default function useMountedRef(): React.MutableRefObject<boolean> {
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  return mounted;
}
